import React from 'react';

export const contextDefault = {
	login: () => {},
	user: {
		isLoggedIn: false,
		roles: []
	}
};

export const Context = React.createContext(contextDefault);
